import { Directive, ElementRef, Input, OnInit, OnChanges, SimpleChanges } from "@angular/core";

const style = getComputedStyle(document.body)

@Directive({ selector: '[sxColor]', standalone: false })
export class ColorDirective implements OnInit, OnChanges {

  @Input() sxColor: 'two' | 'one' | 'three' | 'primary' | 'dark' | 'light' | 'light-two' | 'success' | 'danger' | 'darkGradient' | 'lightGradient' | 'warning' | string;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.updateColor();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['sxColor']) {
      this.updateColor();
    }
  }

  private updateColor() {
    if (!this.sxColor) {
      return;
    }

    switch (this.sxColor) {
      case "dark":
      case "light":
      case "light-two":
      case "success":
      case "danger":
      case "one":
      case "two":
      case "three":
      case "warning":
      case "warning-shade":
      case "primary":
        return this.el.nativeElement.style.color = style.getPropertyValue(`--ion-color-${this.sxColor}`)
      default:
        return this.el.nativeElement.style.color = this.sxColor
    }

  }

}
